import { useTranslation } from 'react-i18next';

const ErrorModal = ({title, message, setModalDataFromChild}) => {
    const { t } = useTranslation();
    const hangleModalClose = (e) => {
        e.preventDefault();
        setModalDataFromChild();
    }


    return (
        <div className="top-0 right-0 absolute z-50">
            <div className={`bg-[#FCE8EC] m-4 shadow-md border border-[#B01030] rounded-xl p-3 space-y-1 sm:min-w-[36rem]`}>
                <div className="flex justify-between items-center">
                    <div className="flex justify-between items-center">
                        <img src={`../../../assets/icons/auth/error.svg`} alt="error" />
                        <h1 className={`text-[#B01030] font-semibold text-lg ml-3`}>{t(`${title.toLowerCase()} message`)}</h1>
                    </div>
                    <div onClick={(e) => hangleModalClose(e)} className="cursor-pointer">
                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                    </div>
                </div>
                <div className="text-light-400 text-base">
                    {message}
                </div>
            </div>
        </div>
    )
}

export default ErrorModal;